/* Native GET forms remain functional without this progressive enhancement. */
(() => {
  if (customElements.get('cave-native-results')) return;
  class CaveNativeResults extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-cave-filter-form]')) return;
        event.preventDefault();
        this.submitFilters(event.target, true);
      }, options);
      this.addEventListener('change', event => {
        const form = event.target.closest('[data-cave-filter-form]');
        if (form && matchMedia('(min-width: 799px)').matches) this.submitFilters(form, false);
      }, options);
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-cave-link],a[data-cave-clear]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.update(new URL(link.href), true, true);
      }, options);
      window.addEventListener('popstate', () => this.update(new URL(location.href), false, false), options);
    }
    disconnectedCallback() { this.controller?.abort(); this.request?.abort(); }
    submitFilters(form, moveFocus) {
      if (!form.reportValidity()) return;
      const min = form.querySelector('[name="filter.v.price.gte"]');
      const max = form.querySelector('[name="filter.v.price.lte"]');
      if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
        this.querySelector('.cave-native__status').textContent = 'Minimum price must be no greater than maximum price.';
        min.focus();
        return;
      }
      const url = new URL(form.action);
      const previous = new URL(location.href);
      for (const key of ['preview_theme_id', '_ab', '_fd', '_sc', 'type', 'options[prefix]', 'options[unavailable]']) {
        if (previous.searchParams.has(key)) url.searchParams.set(key, previous.searchParams.get(key));
      }
      for (const [key, value] of new FormData(form)) if (value !== '') url.searchParams.append(key, value);
      this.update(url, true, moveFocus);
    }
    async update(url, push, moveFocus) {
      if (url.origin !== location.origin) return;
      this.request?.abort();
      const request = this.request = new AbortController();
      const status = this.querySelector('.cave-native__status');
      const activeId = this.contains(document.activeElement) ? document.activeElement.id : '';
      const openIds = [...this.querySelectorAll('details[id][open]')].map(node => node.id);
      const filterOpen = this.querySelector('.cave-native__filters')?.open;
      this.setAttribute('aria-busy', 'true');
      status.textContent = 'Updating results…';
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
      const timeout = setTimeout(() => request.abort(), 12000);
      try {
        const response = await fetch(fetchUrl, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load results');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('cave-native-results [data-cave-content]');
        if (!content || /Liquid error/i.test(content.textContent)) throw new Error('Invalid results');
        if (request !== this.request) return;
        this.querySelector('[data-cave-content]').replaceWith(content);
        this.querySelector('.cave-native__filters').open = filterOpen;
        for (const detail of this.querySelectorAll('details[id]')) detail.open = openIds.includes(detail.id);
        if (push) history.pushState({}, '', url);
        const count = this.querySelector('[data-cave-count]');
        status.textContent = count.textContent.trim();
        if (moveFocus) { count.focus(); count.scrollIntoView({ block: 'start', behavior: 'auto' }); }
        else if (activeId) this.querySelector('#' + CSS.escape(activeId))?.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('cave:results-updated', { bubbles: true }));
      } catch (error) {
        if (request !== this.request || !this.isConnected) return;
        location.assign(url.href);
      } finally {
        clearTimeout(timeout);
        if (request === this.request) this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('cave-native-results', CaveNativeResults);
})();
